import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  background: #fff0e2;
  background-image: linear-gradient(164deg, #fff0e2 30%, #ffffff);

  .blog-container {
    .banner {
      position: relative;
      height: 480px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;

      .shadow {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(112, 112, 112, 0.3);
        z-index: 1;
      }

      .cover-image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .title {
        position: relative;
        color: ${theme.white};
        z-index: 2;
      }
    }

    .blog-content {
      margin-top: 45px;
      padding-bottom: 50px;

      .article-content {
        > .title-block {
          margin-bottom: 30px;

          .title {
            color: ${theme.darkRed};
          }

          .subtitle {
            color: ${theme.darkRed};
            margin-top: 10px;
          }
        }

        .pagination-block {
          display: flex;
          justify-content: center;
          margin-top: 40px;
        }
      }
    }

    .section-subscribe {
      margin-top: 140px;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .article-content {
      padding-bottom: 50px;
    }
  }
`
